import { defineComponent as _defineComponent } from 'vue'
import TUIRoomEngine from '@tencentcloud/tuiroom-engine-js';

import Dialog from '../../common/base/Dialog';
import SvgIcon from '../../common/base/SvgIcon.vue';
import TuiButton from '../../common/base/Button.vue';
import TuiInput from '../../common/base/Input';
import ArrowStrokeSelectDownIcon from '../../common/icons/ArrowStrokeSelectDownIcon.vue';
import useUserInfo from './useUserInfoHooks';
import Avatar from '../../common/Avatar.vue';
import { roomService } from '../../../services';
import TUIMessage from '../../common/base/Message/index';
import { MESSAGE_DURATION } from '../../../constants/message';
import { useBasicStore } from '../../../stores/basic';
import { useRoomStore } from '../../../stores/room';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfoPC',
  props: {
    userId: null,
    userName: null,
    avatarUrl: null,
    isShowEditName: { type: Boolean }
  },
  emits: ['log-out', 'update-user-name'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  userId: string;
  userName: string;
  avatarUrl?: string;
  isShowEditName?: boolean;
};



const userInfoConfig = roomService.getComponentConfig('UserInfo');

const basicStore = useBasicStore();
const roomStore = useRoomStore();

const {
  t,
  showUserControl,
  isUserNameEditorVisible,
  userInfoRef,
  tempUserName,
  handleUserControl,
  showEditUserNameDialog,
  closeUserNameEditor,
} = useUserInfo();



/**
 * Save the new userName
 *
 **/
async function saveUserName(userName: string) {
  if (userName.length === 0) {
    TUIMessage({
      type: 'warning',
      message: t('Username length should be greater than 0'),
      duration: MESSAGE_DURATION.NORMAL,
    });
    return;
  }
  await TUIRoomEngine.setSelfInfo({
    userName,
    avatarUrl: roomStore.localUser.avatarUrl || '',
  });
  basicStore.setUserName(userName);
  roomStore.setLocalUser({ userName });
  emits('update-user-name', userName);
  closeUserNameEditor();
}

return { __sfc: true,emits, userInfoConfig, basicStore, roomStore, t, showUserControl, isUserNameEditorVisible, userInfoRef, tempUserName, handleUserControl, showEditUserNameDialog, closeUserNameEditor, props, saveUserName, Dialog, SvgIcon, TuiButton, TuiInput, ArrowStrokeSelectDownIcon, Avatar }
}

})